import {
  isEmailValid,
  isValidUrl,
} from "../../../../../utils/commonValidation";
import { PHONE_NUMBER_REGEX } from "../../../../../constants/regex";

const validateDropdownAndUrl = ({
  selectedNotification = "",
  testUrl = "",
}) => {
  const errors = {};

  if (!selectedNotification.trim()) {
    errors.selectedNotification = true;
  }
  if (!testUrl.trim() || !isValidUrl(testUrl)) {
    errors.testUrl = true;
  }

  return errors;
};

export const validateTestEventsForm = (values) =>
  validateDropdownAndUrl(values);

export const validate = ({
  selectedNotification = "",
  email = "",
  testUrl = "",
  sms = "",
}) => {
  const errors = validateDropdownAndUrl({ selectedNotification, testUrl });

  const hasEmail = email.trim();
  const hasSms = sms.trim();

  if (!hasEmail && !hasSms) {
    errors.email = true;
    errors.sms = true;
  } else {
    if (hasEmail && !isEmailValid(email)) {
      errors.email = true;
    }
    if (hasSms && !PHONE_NUMBER_REGEX.test(sms)) {
      errors.sms = true;
    }
  }

  return errors;
};
